import { isSupportedWeek, isSupportedYear } from '@shared/helpers';
import { Emojis, LocationCls, ValueCls } from 'app/constants';
import { useAppSelector } from 'app/hooks';
import { getSelectedWeek, getSelectedYear } from 'app/slices/GamesSlice';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

export const CategoryRankingsIndexRoute: React.FC = () => {
  const navigate = useNavigate();
  const selectedWeek = useAppSelector(getSelectedWeek);
  const selectedYear = useAppSelector(getSelectedYear);

  useEffect(() => {
    if (isSupportedWeek(selectedWeek) && isSupportedYear(selectedYear)) {
      const values = `year %c ${selectedYear} %c week %c ${selectedWeek} %c`;
      const msg = `${Emojis.eyes} %c CategoryRankingsIndexRoute %c, ${values}`;
      console.log(msg, LocationCls, '', ValueCls, '', ValueCls, '');
      navigate(`${AppRoutes.CategoryRankings}/${selectedYear}/${selectedWeek.toLowerCase()}`, { replace: false });
    }
  }, [selectedYear, selectedWeek, navigate]);

  return <></>;
};

export default CategoryRankingsIndexRoute;
